import React, { useEffect, useState, useCallback, useMemo } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Table from '../shared/table/Table';
import { FiSave, FiPlus, FiTrash2 } from 'react-icons/fi';
import useTranslations from '../../hooks/useTranslations';
import useUserLanguage from '../../hooks/useUserLanguage';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// ANA BİLEŞEN
const LanguageTranslationEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  // Kullanıcının dilini al ve çevirileri getir
  const userLanguage = useUserLanguage();
  const { translations: trans } = useTranslations(userLanguage);

  const getText = useCallback(
    (key, defaultValue) => (trans && trans[key] ? trans[key] : defaultValue),
    [trans]
  );

  // eski çeviriler (tablodaki)
  const [translations, setTranslations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [languageName, setLanguageName] = useState('');

  // yeni (eklenecek) çeviriler
  const [newTranslations, setNewTranslations] = useState([
    { key: '', value: '' },
  ]);

  useEffect(() => {
    fetchLanguageData();
  }, []);

  // API'den mevcut dil ve çeviri bilgilerini al
  const fetchLanguageData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     const keysResp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/translations/keys`, {

        headers: { Authorization: `Bearer ${token}` },
      });

      const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/languages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setLanguageName(resp.data.language.name || 'Bilinmeyen Dil');

      const translationsData = keysResp.data.map(({ key, trValue }) => ({
        key,
        tr: trValue || '—',
        value: resp.data.translations.find((t) => t.key === key)?.value || '',
      }));

      setTranslations(translationsData);
    } catch (error) {
      console.error('❌ Dil verisi alınamadı:', error);
      alert('Dil bilgisi getirilemedi!');
    }
    setLoading(false);
  };

  // Mevcut tablodaki value değişikliği
  const handleValueChange = useCallback((key, newVal) => {
    setTranslations((prevTranslations) =>
      prevTranslations.map((item) =>
        item.key === key ? { ...item, value: newVal } : item
      )
    );
  }, []);

  // Mevcut çevirileri tek seferde kaydet
  const handleSubmitExisting = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem('token');
      const allTranslations = Object.fromEntries(
        translations.map(({ key, value }) => [key, value.trim()])
      );

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/translations/update/${id}`,
        { translations: allTranslations },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      toast.success(" Çeviriler başarıyla güncellendi!", {
        position: "top-right",
        autoClose: 3000,
      });
      
    } catch (error) {
      console.error('❌ Çeviri güncelleme hatası:', error);
      alert('Çeviriler güncellenemedi!');
    }
    setSaving(false);
  };

  const handleDeleteTranslation = async (key) => {
    confirmAlert({
      title: "Silme İşlemi",
      message: "Bu çeviriyi silmek istediğinizden emin misiniz?",
      buttons: [
        {
          label: "Evet, Sil",
          onClick: async () => {
            try {
              const token = localStorage.getItem("admin_token");
              await axios.delete(
                `${process.env.REACT_APP_API_BASE_URL}/api/translations/delete/${id}/${key}`,
                { headers: { Authorization: `Bearer ${token}` } }
              );
  
              toast.success("Çeviri başarıyla silindi!", {
                position: "top-right",
                autoClose: 3000,
              });
  
              // 1️Silinen çeviriyi state'ten kaldır
              setTranslations((prev) => prev.filter((item) => item.key !== key));
            
            } catch (error) {
              toast.error("Çeviri silinemedi!", {
                position: "top-right",
                autoClose: 3000,
              });
            }
          },
        },
        {
          label: "İptal",
          onClick: () =>
            toast.info("Silme işlemi iptal edildi!", {
              position: "top-right",
              autoClose: 2000,
            }),
        },
      ],
    });
  };
  

  // yeni çeviriler (çoklu satır) ekleme
 
  // 1) Satır eklemek için
  const handleAddNewRow = () => {
    setNewTranslations((prev) => [...prev, { key: '', value: '' }]);
  };

  // 2) Her satırdaki inputu değiştirmek için
  const handleNewInputChange = (index, field, val) => {
    setNewTranslations((prev) => {
      const updated = [...prev];
      updated[index][field] = val;
      return updated;
    });
  };

  const handleBulkAdd = async () => {
    // Boşları ayıkla
    const filtered = newTranslations.filter(
      (row) => row.key.trim() && row.value.trim()
    );
    if (!filtered.length) {
      toast.warn("⚠️ Eklemek için en az 1 geçerli çeviri girmelisiniz!", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
  
    try {
      const token = localStorage.getItem("admin_token");
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/translations/bulk-add/${id}`,
        { translations: filtered },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      toast.success("Yeni çeviriler başarıyla eklendi!", {
        position: "top-right",
        autoClose: 3000,
      });
  
      // 1️Yeni eklenen çevirileri direkt olarak state'e ekle
      setTranslations((prev) => [...prev, ...filtered]);
  
      //  Inputları temizle
      setNewTranslations([{ key: "", value: "" }]);

    } catch (error) {
      console.error("Yeni çeviriler eklenemedi:", error);
      toast.error("Yeni çeviriler eklenemedi!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };
  

  // Tablodaki kolonlar
  const columns = useMemo(
    () => [
      {
        accessorKey: 'key',
        header: () => getText('TABLE_KEY_LABEL'),
        meta: { headerClassName: 'text-start', className: 'text-start key-column' },
      },
      {
        accessorKey: 'tr',
        header: () => getText('TURKISH_VALUE'),
        meta: { headerClassName: 'text-start', className: 'text-start tr-column' },
      },
      {
        accessorKey: 'value',
        header: () => getText('TABLE_VALUE_LABEL'),
        enableGlobalFilter: false,
        meta: { headerClassName: 'text-start', className: 'text-start value-column' },
        cell: ({ row }) => (
          <input
            type="text"
            className="form-control"
            value={row.original.value}
            onChange={(e) => handleValueChange(row.original.key, e.target.value)}
          />
        ),
      },
      {
        accessorKey: 'actions',
        header: () => (
          <div style={{ textAlign: 'center', paddingRight: '50px' }}>
            {getText('TABLE_ACTIONS_LABEL')}
          </div>
        ),
        enableSorting: false,
        meta: { headerClassName: 'text-start', className: 'text-start' },
        cell: ({ row }) => (
          <div className="d-flex justify-content-center">
            <button
              className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
              title={getText('DELETE', 'Sil')}
              onClick={() => handleDeleteTranslation(row.original.key)}
            >
              <FiTrash2 />
            </button>
          </div>
        ),
      },
    ],
    [handleValueChange, getText]
  );

  if (loading) return <p>⏳ Yükleniyor...</p>;

  return (
<div className="container mt-4">
<ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        draggable
        pauseOnHover
      />

{/* ESKİ ÇEVİRİLER KARTI*/}
<div className="card card-body lead-info mb-4">

  <div className="mb-4 d-flex align-items-center justify-content-between">
    <h5 className="fw-bold mb-0">
      <span className="d-block mb-2">
        {languageName} {getText("EXISTING_TRANSLATIONS")}
      </span>
    </h5>
  </div>

  <Table
    data={translations}
    columns={columns}
    getText={getText}
  />

  {/* Kaydet Butonu */}
  <div className="d-flex justify-content-center mt-3">
    <button
      className="btn btn-primary"
      disabled={saving}
      onClick={handleSubmitExisting}
    >
      <FiSave />{" "}
      {saving
        ? getText("SAVING_BTN", "Kaydediliyor...")
        : getText("SAVE_BTN", "Kaydet")}
    </button>
  </div>
</div>

{/* YENİ ÇEVİRİLER KARTI */}
<div className="card card-body general-info">
  <div className="mb-4 d-flex align-items-center justify-content-between">
    <h5 className="fw-bold mb-0">
      <span className="d-block mb-2">
        {getText("NEW_TRANSLATIONS")}
      </span>
    </h5>
  </div>

  {newTranslations.map((row, index) => (
    <div key={index} className="border rounded p-3 mb-3">
      <div className="row mb-3">
        <div className="col-lg-2 fw-medium">
          {getText("TABLE_KEY_LABEL")} {index + 1}
        </div>
        <div className="col-lg-10">
          <input
            type="text"
            className="form-control"
            placeholder={getText("TABLE_KEY_LABEL")}
            value={row.key}
            onChange={(e) => handleNewInputChange(index, "key", e.target.value)}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-2 fw-medium">
          {getText("TABLE_VALUE_LABEL")} {index + 1}
        </div>
        <div className="col-lg-10">
          <input
            type="text"
            className="form-control"
            placeholder={getText("TABLE_VALUE_LABEL")}
            value={row.value}
            onChange={(e) =>
              handleNewInputChange(index, "value", e.target.value)
            }
          />
        </div>
      </div>
    </div>
  ))}

  {/* Yeni Satır Ekle Butonu */}
  <div className="d-flex justify-content-end mb-3">
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={handleAddNewRow}
    >
      <FiPlus /> {getText("ADD_NEW_ROW")}
    </button>
  </div>

  {/* Kaydet (Hepsini Ekle) Butonu*/}
  <div className="d-flex justify-content-center">
    <button className="btn btn-primary" onClick={handleBulkAdd}>
      <FiSave /> {getText("SAVE_BTN")}
    </button>
  </div>
</div>
</div>

  );
};

export default LanguageTranslationEdit;
